import React, { useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  Timestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";

export default function DayBook() {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [rows, setRows] = useState([]);

  const [summary, setSummary] = useState({
    opening: 0,
    received: 0,
    payment: 0,
    closing: 0,
  });

  /* ================= FETCH ================= */
  const fetchDayBook = async () => {
    if (!fromDate || !toDate) {
      alert("Select From & To Date");
      return;
    }

    const from = Timestamp.fromDate(new Date(fromDate + "T00:00:00"));
    const to = Timestamp.fromDate(new Date(toDate + "T23:59:59"));

    const q = query(
      collection(db, "savingLedger"),
      where("createdAt", ">=", from),
      where("createdAt", "<=", to),
      orderBy("createdAt", "asc")
    );

    const snap = await getDocs(q);

    let received = 0;
    let payment = 0;

    const data = snap.docs.map((d) => {
      const x = d.data();

      const dep = Number(x.deposit || 0);
      const wit = Number(x.withdrawal || 0);

      received += dep;
      payment += wit;

      return {
        id: d.id,
        dateTime: x.createdAt?.toDate
          ? x.createdAt.toDate().toLocaleString()
          : x.createdAt || "",
        narration: `${x.memberName || "Member"} (${x.memberId || "-"})`,
        deposit: dep,
        withdrawal: wit,
        voucherId: x.voucherId || "",
        entryBy: x.entryBy || "Admin",
      };
    });

    const opening = 0;
    const closing = opening + received - payment;

    setRows(data);
    setSummary({
      opening,
      received,
      payment,
      closing,
    });
  };

  /* ================= PDF ================= */
  const printPDF = () => {
    const pdf = new jsPDF();
    pdf.text("Day Book Report", 14, 10);

    pdf.text(`Opening : ${summary.opening}`, 14, 18);
    pdf.text(`Received : ${summary.received}`, 14, 25);
    pdf.text(`Payment : ${summary.payment}`, 14, 32);
    pdf.text(`Closing : ${summary.closing}`, 14, 39);

    pdf.autoTable({
      startY: 45,
      head: [
        [
          "Sr",
          "Date & Time",
          "Narration",
          "Deposit",
          "Withdrawal",
          "Voucher",
          "Entry By",
        ],
      ],
      body: rows.map((r, i) => [
        i + 1,
        r.dateTime,
        r.narration,
        r.deposit,
        r.withdrawal,
        r.voucherId,
        r.entryBy,
      ]),
    });

    pdf.save("DayBook.pdf");
  };

  /* ================= EXCEL ================= */
  const exportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "DayBook");
    XLSX.writeFile(wb, "DayBook.xlsx");
  };

  return (
    <div className="container-fluid">
      <h4 className="mb-3">Day Book</h4>

      {/* FILTER */}
      <div className="row mb-3">
        <div className="col-md-3">
          <label>From Date</label>
          <input
            type="date"
            className="form-control"
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>

        <div className="col-md-3">
          <label>To Date</label>
          <input
            type="date"
            className="form-control"
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>

        <div className="col-md-6 d-flex align-items-end gap-2">
          <button className="btn btn-success" onClick={fetchDayBook}>
            Search
          </button>
          <button className="btn btn-danger" onClick={printPDF}>
            PDF
          </button>
          <button className="btn btn-info" onClick={exportExcel}>
            Excel
          </button>
        </div>
      </div>

      {/* CASH IN HAND */}
      <div className="row mb-3">
        <div className="col-md-3">
          <b>Opening:</b> {summary.opening}
        </div>
        <div className="col-md-3 text-success">
          <b>Received:</b> {summary.received}
        </div>
        <div className="col-md-3 text-danger">
          <b>Payment:</b> {summary.payment}
        </div>
        <div className="col-md-3">
          <b>Closing:</b> {summary.closing}
        </div>
      </div>

      {/* TABLE */}
      <table className="table table-bordered table-hover">
        <thead className="table-primary text-center">
          <tr>
            <th>Sr</th>
            <th>Date & Time</th>
            <th>Narration</th>
            <th>Deposit</th>
            <th>Withdrawal</th>
            <th>Voucher</th>
            <th>Entry By</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((r, i) => (
            <tr key={r.id}>
              <td>{i + 1}</td>
              <td>{r.dateTime}</td>
              <td>{r.narration}</td>
              <td className="text-success">{r.deposit}</td>
              <td className="text-danger">{r.withdrawal}</td>
              <td>{r.voucherId}</td>
              <td>{r.entryBy}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}